import { Grid } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { TextInput } from "components/FormControls/TextInput";
import { ReactComponent as XCloseIcon } from "components/Icons/x-close.svg";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";
import { memo } from "react";
import { RequiredFieldLabel } from "../FormControls/RequiredFieldLabel";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    deleteWrapper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "50%",
      backgroundColor: theme.gray100,
      width: "32px",
      minWidth: "32px",
      height: "32px",
      cursor: "pointer",
    },
  }),
);

interface Props {
  remove: (index: number) => void;
  index: number;
  name: string;
}

export const CustomAttribute = memo(({ remove, index, name }: Props) => {
  const { message } = useMessage();
  const classes = useStyles();

  return (
    <Grid item xs={12} container rowSpacing={12} columnSpacing={16}>
      <Grid item xs={5.5}>
        <TextInput
          label={<RequiredFieldLabel text={message({ id: "key" })} />}
          name={`${name}.key`}
          data-test-id={`custom-attribute-${index}-key`}
          width="100%"
        />
      </Grid>
      <Grid item xs={5.5}>
        <TextInput
          label={<RequiredFieldLabel text={message({ id: "value" })} />}
          name={`${name}.value`}
          data-test-id={`custom-attribute-${index}-value`}
          width="100%"
        />
      </Grid>
      <Grid
        item
        xs={1}
        alignItems="center"
        justifyContent="center"
        margin="auto"
      >
        <div className={classes.deleteWrapper} onClick={() => remove(index)}>
          <XCloseIcon />
        </div>
      </Grid>
    </Grid>
  );
});
